import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_INPUT_MINI_BANNER} from "../../utils/input-field-list-static-page";
import {setWaste4ChangeErrorMessage, setWaste4ChangeMiniBannerDetail} from "../../reducers/waste-4-change.reducer";
import React, {useEffect} from "react";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const MiniBanner = () => {
    const dispatch = useDispatch()
    const {miniBannerDetail, waste4ChangeErrorMessage} = useSelector(state => state.waste4ChangeReducer)
    const {fetching: getMiniBanner} = useFetch(API.W4C_GET_MINI_BANNER)
    const {fetching: updateMiniBanner, isLoading} = useFetch(API.W4C_UPDATE_MINI_BANNER)
    let fieldListInput = FIELD_LIST_INPUT_MINI_BANNER
    let showMiniBanner = {
        label: 'Mini Banner',
        key: 'show_mini_banner',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setWaste4ChangeMiniBannerDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateMiniBanner(miniBannerDetail).then(response => {
            dispatch(setWaste4ChangeErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Mini Banner Updated'))
            dispatch(setWaste4ChangeMiniBannerDetail(response?.data))
        }).catch(err => {
            dispatch(setWaste4ChangeErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getMiniBanner().then(response => {
            dispatch(setWaste4ChangeMiniBannerDetail(response?.data))
        })

        return () => {
            dispatch(setWaste4ChangeErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={miniBannerDetail}
            switchToggleField={showMiniBanner}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={waste4ChangeErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default MiniBanner